import 'css/pages/lessons.css'
import { verifyLogin } from 'util/cache'
import { useDocTitle } from 'util/hooks'

import { SearchBar } from 'lesson-library/search-bar'
import { SearchResults } from 'lesson-library/search-results'
import React, { useState, useEffect } from 'react'
import { useNavigate, useSearchParams, Link } from 'react-router-dom'
import { LessonsContextProvider } from 'lesson-library/context'

export const Lessons = () => {
	const navigate = useNavigate()
	const [searchParams] = useSearchParams()
	const classId = searchParams.get('classId') || undefined

	const [ query, setQuery ] = useState("")

	useEffect(() => {
		verifyLogin(navigate)
	}, [navigate])

	useDocTitle('All for One - Lessons')

	return (
		<LessonsContextProvider query={query}>
			{/* mockup .page-head: eyebrow / sentence-case h1 / rule / sub-copy on
			    the left, the primary action on the right. Staging had a lone
			    centred Title-Case h1 and no action. */}
			<div className="lessons-page-head">
				<div className="lessons-page-head-text">
					<span className="page-eyebrow">Every lesson you've built</span>
					<h1>My lesson library</h1>
					<div className="page-rule" />
					<p>Every lesson you have generated, ready to open, assign to a classroom or hand out.</p>
				</div>
				<Link to="/upload-lessons" className="lessons-plan-btn">
					<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round">
						<line x1="12" y1="5" x2="12" y2="19" /><line x1="5" y1="12" x2="19" y2="12" />
					</svg>
					Plan a new lesson
				</Link>
			</div>
			<SearchBar
				placeholder="Search for lessons"
				onChange={({ target }) => setQuery(target.value)}
			/>
			<SearchResults query={query} classId={classId}/>
		</LessonsContextProvider>
	)
}
